export function fmtWeight(w: number | null | undefined, units: string): string {
  if (w == null) return '—';
  const n = Math.round(Number(w) * 100) / 100;
  return `${n} ${units}`;
}

export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
}

export function fmtDuration(s: number): string {
  const m = Math.round(s / 60);
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}m`;
}

export function fmtVolume(v: number, units: string): string {
  const n = Number(v) || 0;
  return `${n >= 10000 ? `${(n / 1000).toFixed(1)}k` : Math.round(n).toLocaleString()} ${units}`;
}

/** "5 × 5 @ 100 kg", "3 × 12", "3 sets" */
export function fmtPlan(sets: number, reps: number | null, weight: number | null, units: string): string {
  const base = reps != null ? `${sets} × ${reps}` : `${sets} ${sets === 1 ? 'set' : 'sets'}`;
  return weight != null ? `${base} @ ${fmtWeight(weight, units)}` : base;
}
